// extracted by mini-css-extract-plugin
module.exports = {"cell_container":"Cell_cell_container__1dCSv","cell_high":"Cell_cell_high__1Wop9","cell_medium":"Cell_cell_medium__3f3e2","cell_low":"Cell_cell_low__1SROd"};